export default "__VITE_ASSET__986b3e06__"